export default __webpack_public_path__ + "static/media/duke-rhodes.631ee101.png";